import { closest } from '@utils/domUtils';

/* global FormValidation */

export default class Validator {
  constructor(validators, callback) {
    this.validators = Array.isArray(validators) ? validators : [validators];
    this.callback = callback;
  }

  async validate() {
    const results = await Promise.all(this.validators.map(v => v.validate()));
    const valid = results.filter(result => result !== 'Valid').length === 0;

    if (this.callback) {
      console.log(valid);
      this.callback(valid);
    }

    return valid ? 'Valid' : 'Invalid';
  }
}

Validator.create = (form, data, plugins = {}) => {
  const defaultData = {
    fields: {},
    plugins: {
      trigger: new FormValidation.plugins.Trigger({
        event: 'input change validate',
      }),

      bootstrap: new FormValidation.plugins.Bootstrap({
        defaultMessageContainer: false,
      }),

      message: new FormValidation.plugins.Message({
        clazz: 'fv-help-block',
        container: (field, ele) => {
          return closest(ele, '.form-group');
        },
      }),
    },
  };

  const options = data.fields
    ? Object.assign({}, defaultData, data)
    : {
        ...defaultData,
        fields: data,
      };

  const validator = FormValidation.formValidation(form, {
    ...options,
    plugins: {
      ...options.plugins,
      ...plugins,
    },
  });

  return new Validator(validator);
};
